import { type ReactNode, useEffect, useState } from 'react';
import styled from 'styled-components';

import { VFlex } from '@/components/base';
import Transition from '@/components/Common/Transition';
import { animation } from '@/styles/style';

type Props = {
  items: ReactNode[];
  css?: StyledCss;
  repeat?: boolean;
  interval?: number;
};

const Rotator = (props: Props) => {
  const { items, css, repeat = true, interval = 3000 } = props;
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentIndex((prevIndex) => {
        if (prevIndex === items.length - 1) {
          if (repeat) {
            return 0;
          }
          return prevIndex;
        }
        return prevIndex + 1;
      });
    }, interval);

    return () => clearInterval(intervalId);
  }, [items, interval, repeat]);

  return (
    <Style css={css}>
      <Transition
        key={currentIndex}
        duration={500}
        status={true}
        animations={{
          in: animation.growDownIn,
          out: animation.growDownOut,
        }}
      >
        {items[currentIndex]}
      </Transition>
    </Style>
  );
};

const Style = styled(VFlex)`
  position: relative;
  align-items: center;
  ${({ css }) => css};
`;

export default Rotator;
